import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, TrendingUp, TrendingDown, Activity, ShieldAlert } from 'lucide-react';

function fmtPct(v) {
    if (v == null || isNaN(v)) return 'n/a';
    const n = Number(v);
    return `${n >= 0 ? '+' : ''}${n.toFixed(1)}%`;
}

export default function MorningBrief({ brief }) {
    const { t } = useTranslation();
    if (!brief) {
        return (
            <div className="v3-card v3-cc-card">
                <h3>{t('Morning Brief')}</h3>
                <div className="v3-text-muted" style={{ fontSize: 13 }}>{t('No brief available yet.')}</div>
            </div>
        );
    }

    const risks = Array.isArray(brief.riskAlerts) ? brief.riskAlerts : [];
    const sales = brief.salesSummary;
    const tenantCount = brief.activeTenantCount;
    const anomalyCount = brief.anomalyCount ?? 0;
    const salesUp = sales ? sales.growthPct >= 0 : true;

    return (
        <div className="v3-card v3-cc-card">
            <h3>{t('Morning Brief')}</h3>

            {/* KPI summary row */}
            <div className="v3-cc-mb-kpis">
                <div className="v3-cc-mb-kpi tone-accent">
                    <span className="v3-cc-mb-kpi-icon"><Users size={18} strokeWidth={2.2} /></span>
                    <span className="v3-cc-mb-kpi-value">{tenantCount ?? '—'}</span>
                    <span className="v3-cc-mb-kpi-label">{t('Active Tenants')}</span>
                </div>
                {sales && (
                    <div className={`v3-cc-mb-kpi ${salesUp ? 'tone-positive' : 'tone-negative'}`}>
                        <span className="v3-cc-mb-kpi-icon">
                            {salesUp ? <TrendingUp size={18} strokeWidth={2.2} /> : <TrendingDown size={18} strokeWidth={2.2} />}
                        </span>
                        <span className="v3-cc-mb-kpi-value">{fmtPct(sales.growthPct)}</span>
                        <span className="v3-cc-mb-kpi-label">{t('YTD Sales vs LY')}</span>
                    </div>
                )}
                <div className={`v3-cc-mb-kpi ${anomalyCount > 0 ? 'tone-negative' : 'tone-positive'}`}>
                    <span className="v3-cc-mb-kpi-icon"><Activity size={18} strokeWidth={2.2} /></span>
                    <span className="v3-cc-mb-kpi-value">{anomalyCount}</span>
                    <span className="v3-cc-mb-kpi-label">{t('Anomalies Today')}</span>
                </div>
                <div className={`v3-cc-mb-kpi ${risks.length > 0 ? 'tone-negative' : 'tone-positive'}`}>
                    <span className="v3-cc-mb-kpi-icon"><ShieldAlert size={18} strokeWidth={2.2} /></span>
                    <span className="v3-cc-mb-kpi-value">{risks.length}</span>
                    <span className="v3-cc-mb-kpi-label">{t('Risk Alerts')}</span>
                </div>
            </div>

            {/* Risk alerts section */}
            {risks.length > 0 && (
                <div className="v3-cc-mb-risks">
                    <h4 className="v3-cc-mb-section-title">{t('Top Risks')}</h4>
                    <div className="v3-cc-mb-risk-list">
                        {risks.map((r, i) => (
                            <div key={i} className="v3-cc-mb-risk-row">
                                <span className="v3-cc-mb-risk-rank">{i + 1}</span>
                                <span className={`v3-cc-dot ${r.risk || 'medium'}`} />
                                <span className="v3-cc-mb-risk-name">{r.tenant}</span>
                                <span className="v3-cc-mb-risk-ocr">
                                    {t('OCR')} {fmtPct(r.ocr)}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
